/**
 * The code bellow is obfuscated to avoid exposure CWE-209
 * do not try to clean it up, was done with the intention of being hard to read
 */

export function decodeInBrowserText(encoded: string): string {
  const xorKey = decodeBase64(getXorKey());

  // 1) arquivo Base64 → bytes com XOR aplicado
  const xorBytes = decodeBase64(encoded);           // atob

  // 2) Desfaz o XOR
  const keyBytes = getTextBytesEncode(xorKey);
  const base64JsonBytes = new Uint8Array(xorBytes.length);
  for (let i = 0; i < xorBytes.length; i++) {
    base64JsonBytes[i] = xorBytes.charCodeAt(i) ^ keyBytes[i % keyBytes.length];
  }

  // 3) Bytes → string Base64
  const base64Json = getTextBytesDecode(base64JsonBytes);

  // 4) Base64 → JSON string
  return decodeBase64(base64Json);                  // atob novamente
}

export function decodeBase64(encoded: string): string {
    return atob(encoded);
}

function getTextBytesEncode(text: string): Uint8Array {
    const encoder = new TextEncoder();
    return encoder.encode(text);
}
function getTextBytesDecode(text: Uint8Array): string {
    const decoder = new TextDecoder('utf-8', { fatal: true });
    return decoder.decode(text);
}

function getXorKey(): string {
    return 'MzY3Nzc0YmQtZTBmZC00YTYxLTkxYTgtMjhiZDAzYTY4Yzlh'; // sua chave base64
}

function applyXor(index: number, decodedBytes: string, keyBytes: Uint8Array) {
    return decodedBytes.charCodeAt(index) ^ keyBytes[index % keyBytes.length];
}
